import React,{useState} from "react";
import cx from 'classnames';
import {Collapse} from 'antd';
import {DownOutline} from "antd-mobile-icons";
import MobileComponentWrapper from "@/components/MobileComponentWrapper";
import PcComponentWrapper from "@/components/PcComponentWrapper";
import styles from './styles.module.less';

const {Panel} = Collapse;

type TSpread = {
  signupText?: string[],
}

const Spread:React.FC<TSpread> = ({signupText=[]}) => {
  const [isSpread, setIsSpread] = useState(true);
  return (
    <div className={styles.spread_wrapper}>
      <Collapse defaultActiveKey="1" ghost expandIconPosition="right" onChange={() => {
        setIsSpread(!isSpread);
      }}>
        <Panel showArrow={false} header={(
          <div className={styles.title}>
            <span>报名须知</span>
            <MobileComponentWrapper>
              <DownOutline className={cx(styles.icon, isSpread && styles.icon_rotate)}/>
            </MobileComponentWrapper>
            <PcComponentWrapper>
              <span className={styles.icon}>{isSpread ? '收起':'展开'}</span>
            </PcComponentWrapper>
          </div>
        )} key="1">
          <div style={{paddingTop: 16}}>
            {signupText.map((item) => {
              return (
                <h3 className={styles.body_item} key={item} dangerouslySetInnerHTML={{__html: item}}/>
              )
            })}
          </div>
        </Panel>
      </Collapse>
    </div>
  )
}
export default Spread
